import React, { Component } from 'react';
import {Container,Row} from 'reactstrap';
import { connect } from 'react-redux'

import FavIcon from '../app/FavIcon';
import *  as Actions from './RegisterActions';
import {entityGet} from '../entity/Entity';
import RegistrationForm from '../registrationform/RegistrationForm'
import RegistrationHeader from './RegistrationHeader';

import './Registration.css';


class Registration extends Component {
  constructor(props) {
    super(props);

    this.unionid = this.props.match.params.unionid;
    
    if (this.props.match.params.clubid) {
      sessionStorage.removeItem('ClubId');
    }

    if (sessionStorage.getItem('ClubId')) {
      this.clubid = sessionStorage.getItem('ClubId');
    } else {
      this.clubid = this.props.match.params.clubid;
    }


    this.getClub();

  }

  componentDidMount() {
    if (this.props.registration.club.Name) {
      document.title = "Aanmelden " + this.props.registration.club.Name;
    } else {
      document.title = "Aanmelden ";
    }
  }

  getClub() {
    if (!this.clubid) {
      // Invalid url - forward
      this.props.history.push("/" + this.unionid );
      return;
    }

    this.props.fetchingClub()
    const parameters = {'UnionId': this.unionid, 'ClubId': this.clubid};
    entityGet("Club", parameters, this.props.fetchClubSuccess, this.props.fetchClubFailure);
  }

  render() {
    var formClass = (this.props.registration.submitting) ? 'loading' : 'done';
    if (this.props.registration.club.Name // indicates loading is done
      && this.props.match.params.clubid === this.clubid // we approached this page directly by the clubid
      && !this.props.registration.club.HasClubsite
      && this.unionid !== 'Generic') {
      // Direct link is not allowed for non-clubsites clubs
        this.props.history.push("/" + this.unionid );
        return <div />;
    }

    return (
      <div className="App">
        <FavIcon isKNVB={this.unionid === 'KNVB'} />
        <Container fluid={true}>
          <Row>
            <Container fluid={true} className={"ContentForm Body " + formClass}  >
              <RegistrationHeader
                unionid={this.unionid}
                clubName={this.props.registration.club.Name}
                clubCity={this.props.registration.club.Address.City}
                clubLogo={this.props.registration.club.Logo} />
                <RegistrationForm
                    unionid={this.unionid}
                    clubid={this.clubid} />
            </Container>
          </Row>
          <Row>
            <div className="ml-auto" >
              <img className="sl-logo" src="/img/sportlink_logo.png" alt="Sportlink logo" />
            </div>
          </Row>
        </Container>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  registration: state.registration,
})

const mapDispatchToProps = dispatch => ({
  fetchingClub: () => dispatch(Actions.fetchingClub()),
  fetchClubSuccess: (data) => dispatch(Actions.fetchClubSuccess(data)),
  fetchClubFailure: () => dispatch(Actions.fetchClubFailure()),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Registration)



// WEBPACK FOOTER //
// ./src/registration/Registration.jsx